import moment from "moment";

export class BookingsByDateQuery {
  constructor(from, to, venueDetailsId) {
    this.from = from;
    this.to = to;
    this.venueDetailsId = venueDetailsId;
  }

  static create(date, venueDetails) {
    let startTimeOfDay = venueDetails.startTimeOfDay.split(":");

    let nightStart = moment(date);
    nightStart = moment
      .utc([nightStart.year(), nightStart.month(), nightStart.date()])
      .add(startTimeOfDay[0], "hours")
      .add(startTimeOfDay[1], "minuttes");
    let nightEnd = moment(nightStart).add(1, "days");

    return new BookingsByDateQuery(
      nightStart.toJSON(),
      nightEnd.toJSON(),
      venueDetails ? venueDetails.venueDetailsId : undefined
    );
  }
}
